import React from 'react';

export function PasswordIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 2 4 5v4c0 4 2.5 6.999 6 8.999 3.5-2 6-5 6-9V5z"
      />
      <path fill="#000" d="M9.999 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M9.999 11v2"
      />
    </svg>
  );
}
